import { Box, Typography } from '@mui/material'
import React from 'react'
import CommonDrawar from '../../components/GroupsTable/CommonDrawar/CommonDrawar'
import ReloadBtn from '../../Layouts/AnimatedLayout/ReloadBtn'
import { useSessionContex } from '../../SessionContex'
import NotificationList from './NotificationList'

interface NotificationDetailsProps {
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>
  open: boolean
}

const NotificationDetails = ({ open, setOpen }: NotificationDetailsProps) => {
  const { notificationListReCall, setNotificationListReCall } = useSessionContex()
  return (
    <CommonDrawar
      rootClassName='notification-drawar'
      open={open}
      onClose={() => {
        setOpen?.(false)
      }}
      size='default'
      title={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography sx={{ fontWeight: 700 }}>Notifications</Typography>
          <ReloadBtn setReCall={setNotificationListReCall} reCall={notificationListReCall} />
        </Box>
      }
      className='notification-drawar'
    >
      <NotificationList open={open} setOpen={setOpen} />
    </CommonDrawar>
  )
}

export default NotificationDetails
